<template>
  <el-container class="doc" direction='vertical'>
    <div class="search-container">
      <div class="v-text">会员总数：<span>{{statisticsInfo.total}}</span>（已转入<span>{{statisticsInfo.transfered}}</span>人）</div>
      <div class="v-text">待转入：<span>{{statisticsInfo.untransfered}}人</span></div>
      <div class="v-text">充值会员：<span>{{statisticsInfo.recharge_all}}人</span></div>
      <div class="v-text">今日新增充值会员：<span>{{statisticsInfo.recharge_today}}人</span></div>
      <div class="v-text">本月新增充值会员：<span>{{statisticsInfo.recharge_month}}人</span></div>
    </div>
    <div class="search-container">
      <div class="v-search-btn">
        <el-date-picker value-format="yyyy-MM-dd" class="v-date" v-model="valuedate" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
        </el-date-picker>
        <el-input style="margin-left:16px;" v-model="valueid" clearable placeholder="请输入用户ID/手机号"></el-input>
        <el-button type="primary" icon="el-icon-search" @click="clickSearch" size="medium">查询</el-button>
        <el-button type="primary" icon="el-icon-download" @click="clickExport" size="medium">导出</el-button>
      </div>
      <!-- <div class="v-text">新增充值：<span>91人</span></div>
      <div class="v-text">充值会员：<span>90人</span></div> -->
    </div>
    <el-container direction='vertical' class="mian-container">
      <div class="scrollbar-container">
        <el-scrollbar>
          <el-table v-loading="isLoading" :data="tableData" stripe highlight-current-row>
            <el-table-column align="center" width="250px" label="昵称/会员ID">
              <template slot-scope="scope">
                <div class="pay-member-photo">
                  <img :src="scope.row.wxheadurl" />
                </div>
                <div v-if="scope.row.name!==''" class="pay-member-name">{{ scope.row.name }}<br />ID：{{ scope.row.mid }}</div>
                <div v-else class="pay-member-name">{{ scope.row.wxname }}<br />ID：{{ scope.row.mid }}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="电话号码">
              <template slot-scope="scope">
                <span>{{ scope.row.mobile }} </span>
              </template>
            </el-table-column>
            <!-- <el-table-column align="center" label="生日">
              <template slot-scope="scope">
                <span>{{ scope.row.birthday }} </span>
              </template>
            </el-table-column> -->
            <el-table-column align="center"  label="最近消费">
              <template slot-scope="scope">
                <span>{{ scope.row.lastspend }} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="消费次数">
              <template slot-scope="scope">
                <span>{{ scope.row.spendtimes }} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="累计消费">
              <template slot-scope="scope">
                <span>{{ scope.row.spendamount }} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="累计充值">
              <template slot-scope="scope">
                <span>{{ scope.row.rechargeamount }} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="充值次数">
              <template slot-scope="scope">
                <span>{{ scope.row.rechargetimes }} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="转入余额">
              <template slot-scope="scope">
                <span>{{ scope.row.transfered }} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="会员余额">
              <template slot-scope="scope">
                <span>{{ scope.row.balance }} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="会员积分">
              <template slot-scope="scope">
                <span>{{ scope.row.points }} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" min-width="160">
              <template slot-scope="scope">
                <el-button @click="handleGetRecords (scope.row)" size="mini">
                  <span>充值消费明细</span>
                </el-button>
                <el-button @click="handleBindBalance (scope.row)" size="mini">
                  <span>取回余额</span>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-scrollbar>
      </div>
      <el-pagination @current-change="currentChange" background v-if="total>20" layout="prev, pager, next" :current-page="page" :page-size="pageSize" :total="total">
      </el-pagination>
    </el-container>
    <detail-modal ref="modaldetail" @ok="modalDetailOk"></detail-modal>
  </el-container>
</template>
<script>
import {
  searchMemberList,
  memberStatistics,
  bindBalance
} from '@/views/webpc/MemberManagement/MemberList/apis'
import DetailModal from './modules/DetailModal'
export default {
  components: { DetailModal },
  data () {
    return {
      isLoading: false,
      pageSize: 20,
      page: 1,
      total: 0,
      radio: '1',
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      valuedate: null,
      valueid: '',
      tableData: [],
      desc: '',
      params: {},
      statisticsInfo: {}
    }
  },
  methods: {
    // 分页
    currentChange (val) {
      this.page = val
      this.loadData()
    },
    loadData () {
      this.isLoading = true
      let data = new FormData()
      data.append('page', this.page)
      data.append('size', this.pageSize)
      data.append('keywords', this.valueid)
      if (this.valuedate) {
        data.append('startdate', this.valuedate[0])
        data.append('enddate', this.valuedate[1])
      }
      searchMemberList(data)
        .then((result) => {
          this.isLoading = false
          if (result) {
            this.tableData = result.data.list
            this.total = result.data.pager.records
          }
        })
        .catch((error) => {
          if (error) {
            this.isLoading = false
          }
        })
    },
    clickSearch () {
      this.page = 1
      this.loadData()
    },
    // 会员统计
    getMemberStatistics () {
      memberStatistics().then((result) => {
        if (result) {
          this.statisticsInfo = result.data
        }
      })
    },
    clickExport () {
      window.open('/api/Admin/Member/exportMemberList')
    },
    // 消费明细
    handleGetRecords (obj) {
      this.$refs.modaldetail.show(obj)
    },
    // 取回余额
    handleBindBalance (obj) {
      this.$prompt('请输入旧会员号', '取回余额', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[0-9]*$/,
        inputErrorMessage: '旧会员号格式不正确'
      })
        .then(({ value }) => {
          this.getBindBalance(obj.mid, value)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          })
        })
    },
    getBindBalance (mid, oldMid) {
      let data = new FormData()
      data.append('mid', mid)
      data.append('old_mid', oldMid)
      bindBalance(data).then((result) => {
        if (result) {
          this.loadData()
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
        }
      })
    },
    modalDetailOk () {
      // this.loadData()
    }
  },
  mounted () {
    this.getMemberStatistics()
    this.loadData()
  }
}
</script>



// WEBPACK FOOTER //
// src/views/webpc/MemberManagement/MemberList/Member.vue